export const FLASH_KEY = 'js_flash';
export const setFlash = (message, status) => {
  window.sessionStorage.setItem(FLASH_KEY, JSON.stringify({ message, status }));
}

export const getFlash = () => {
  const jsFlash = window.sessionStorage.getItem(FLASH_KEY);
  let result = {};
  if(!jsFlash){
    return result;
  }
  try {
    result = JSON.parse(jsFlash);
  } catch (error) {}
  return result;
}

export const removeFlash = () => {
  window.sessionStorage.removeItem(FLASH_KEY);
}
